import { combineReducers } from 'redux';
import { fromJS } from 'immutable';
import getApiReducer from '../../../../common/utils/getApiReducer';
import {
  ADD_SWING_TO_SUBMITTAL,
  GET_SWING_SUBMITTALS,
  GET_SWING_SUBMITTAL_TYPES,
  PURCHASE_SWING_SUBMITTALS,
  UPLOADING_SWING_SUBMITTAL_PROGRESS,
  UPLOADING_SWING_SUBMITTAL_COMPLETE,
} from './actions';

const uploadingSwingSubmittalProgress = (state = {}, action) => {
  if (action.type === UPLOADING_SWING_SUBMITTAL_PROGRESS) {
    return Object.assign({}, state, {
      [action.swingSubmittalId]: { loaded: action.loaded, total: action.total },
    });
  }

  if (action.type === UPLOADING_SWING_SUBMITTAL_COMPLETE) {
    const newState = Object.assign({}, state);

    delete newState[action.swingSubmittalId];

    return newState;
  }

  return state;
};

const submittalsReducer = getApiReducer(GET_SWING_SUBMITTALS);
const submittals = (state, action) => {
  const nextState = submittalsReducer(state, action);
  if (action.type === `${PURCHASE_SWING_SUBMITTALS}_SUCCESS`) {
    return nextState.set('data', nextState.get('data').concat(fromJS(action.json)));
  }

  if (action.type === `${ADD_SWING_TO_SUBMITTAL}_SUCCESS`) {
    const data = nextState.get('data');
    const index = data.findIndex(item => item.get('id') === action.json.id);

    return nextState.set('data', data.set(index, fromJS(action.json)));
  }
  return nextState;
};

export default combineReducers({
  addSwingToSubmittal: getApiReducer(ADD_SWING_TO_SUBMITTAL),
  purchase: getApiReducer(PURCHASE_SWING_SUBMITTALS),
  submittals,
  types: getApiReducer(GET_SWING_SUBMITTAL_TYPES),
  uploadingSwingSubmittalProgress,
});



// WEBPACK FOOTER //
// ./src/subscription/coaching/swing-submittals/redux/reducers.js